import { CardPricing } from '@curology/ui-components-web/react/Card/CardPricing';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { usePurchaseContext } from '@/components/product-selection/hooks/usePurchaseContext';
import { useTrialSizeItemPrices } from '@/components/product-selection/hooks/useTrialSizeItemPrices';
import { DATA_KEYS } from '@/consts/dataKeys';
import {
  getCardFullSizeItemPrices,
  getCardTrialSizeItemPrices,
  getDisplayPrices,
  getSalePriceSubscription,
} from '@/helpers/productSelectionAndCheckout/helpers';
import { type Card } from '@/types/productSelectionAndCheckout/types';

export const RxCardPricing = ({ rxCard }: { rxCard: Card }) => {
  const { flags, fullSizeItemPrices } = useDataProvider(
    DATA_KEYS.productSelection,
  );
  const { purchaseContext } = usePurchaseContext();
  const trialSizeItemPrices = useTrialSizeItemPrices();
  const cardTrialSizeItemPrices = getCardTrialSizeItemPrices(
    rxCard,
    flags.isTwoMonthFirstShipment,
    trialSizeItemPrices,
  );
  const cardFullSizeItemPrices = getCardFullSizeItemPrices(
    rxCard,
    fullSizeItemPrices,
  );

  const { price, salePrice } = getDisplayPrices(
    cardTrialSizeItemPrices,
    cardFullSizeItemPrices,
    undefined,
    purchaseContext,
  );

  return (
    <div className="cur-flex cur-flex-wrap cur-items-center">
      <CardPricing
        className={flags.isTwoMonthTrialWith50PctOff ? 'cur-mr-1' : ''}
        price={price}
        salePrice={salePrice}
        salePriceSubscription={
          salePrice ? getSalePriceSubscription(rxCard, flags) : undefined
        }
      />
      {flags.isTwoMonthTrialWith50PctOff && (
        <Typography className="cur-text-brand" size="meta">
          (1 month FREE!)
        </Typography>
      )}
      {flags.isTwoMonthTrialWith1995Rx && (
        <Typography className="cur-text-brand" size="meta">
          (1+ month FREE!)
        </Typography>
      )}
    </div>
  );
};
